/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RefundInputs */

const cs_enum_refund = /** @type {(inputs: Enum_RefundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vrácení`)
};

const en_enum_refund = /** @type {(inputs: Enum_RefundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund`)
};

/**
* | output |
* | --- |
* | "Refund" |
*
* @param {Enum_RefundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_refund = /** @type {((inputs?: Enum_RefundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RefundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_refund(inputs)
	return cs_enum_refund(inputs)
});